module.exports = __webpack_public_path__ + "media/old_images/image-promo-sheeps-7be5e034.jpg";